import mushinlabFullLogo from "../images/DP Mushin Labs.png";
import mushinlabHalfLogo from "../images/WHITE.png";


export const images = {
  mushinlabFullLogo: mushinlabFullLogo,
  mushinlabHalfLogo: mushinlabHalfLogo,
  CompanyLogo: `https://mushin-labs.s3.ap-south-1.amazonaws.com/SL-Fasteners/SL+Logo.png`,
};

export const textInputs = {
  companyName: "SL FASTENERS PVT. LTD.",
};
